export const isNumberNotEmpty = (num: number | undefined | null): boolean => {
  return num !== undefined && num !== null && !isNaN(num);
};
